import { initializeApp } from 'https://www.gstatic.com/firebasejs/10.14.1/firebase-app.js';
import { getAuth, onAuthStateChanged, signOut } from 'https://www.gstatic.com/firebasejs/10.14.1/firebase-auth.js';

// opsagents-studio-prod — the CUSTOMER auth project (isolated from opsagent-prod, the
// internal/admin project). The apiKey below is the PUBLIC web client key: it ships in
// every browser bundle and is NOT a secret (Firebase security is enforced by Auth rules
// + backend token verification, not by hiding this key). P2-1 (IBWiHiNM): repointed off
// opsagent-prod so the storefront signin surface authenticates against studio-prod, whose
// requireAuth enforces email_verified. Config salvaged from closed PR #66.
const firebaseConfig = {
  apiKey: 'AIzaSyAPwzm3n3A-6aSdiuiBm6EF-nAGalaQn7Q',
  authDomain: 'opsagents-studio-prod.firebaseapp.com',
  projectId: 'opsagents-studio-prod',
  storageBucket: 'opsagents-studio-prod.firebasestorage.app',
  messagingSenderId: '867234692115',
  appId: '1:867234692115:web:d7360a35333674127b13e6',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

onAuthStateChanged(auth, (user) => {
  // Header bar and mobile drawer each render a menu. First-match would fill
  // only the drawer (it is earlier in the document) and leave the icon stale.
  const menus = document.querySelectorAll('[data-account-menu]');
  if (!menus.length || !user) return;
  menus.forEach((menu) => swapMenuToSignedIn(menu, user));
});

function swapMenuToSignedIn(menu, user) {
  const name = (user.displayName || user.email || '').split(/[\s@]/)[0] || 'there';

  // SYKMBm5f AC-2: the menu now SERVER-RENDERS its signed-in branch, keyed on the one
  // Firebase gate (data-studio-auth-gate="user", revealed by studio-auth-gate.js). When
  // that branch exists this module only fills the greeting and binds Log out — it does
  // not rebuild the menu from a second copy of the markup. The innerHTML swap below is
  // kept for any older template that still ships a `customer`-branched menu.
  const serverUser = menu.querySelector('[data-studio-auth-gate="user"]');
  if (serverUser) {
    const greeting = serverUser.querySelector('[data-greeting]');
    if (greeting) {
      const tpl = greeting.getAttribute('data-greeting-template');
      // Replacer FUNCTION, not a string: `$&` / `$'` in a display name are replacement patterns.
      greeting.textContent = tpl && tpl.includes('%{name}') ? tpl.replace('%{name}', () => name) : 'Hi, ' + name;
      const trigger = serverUser.querySelector('[data-account-trigger]');
      if (trigger) trigger.setAttribute('aria-label', greeting.textContent);
    }
    const signout = serverUser.querySelector('[data-signout]');
    if (signout && !signout.dataset.bound) {
      signout.dataset.bound = '1';
      signout.addEventListener('click', async () => {
        try {
          await signOut(auth);
        } catch (err) {
          console.error('Sign out failed:', err);
        } finally {
          window.location.href = '/';
        }
      });
    }
    return;
  }

  // Build DOM without interpolating user data into innerHTML (XSS prevention)
  menu.innerHTML = `
    <button class="studio-account-trigger" type="button"
            aria-haspopup="true" aria-expanded="false"
            data-account-trigger>
      <span class="studio-account-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none"
             stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </span>
      <span class="studio-account-label" data-greeting></span>
      <span class="studio-account-caret" aria-hidden="true">&#9662;</span>
    </button>
    <div class="studio-account-dropdown" role="menu" data-account-dropdown hidden>
      <a href="/pages/my-studio" role="menuitem">My Studio</a>
      <a href="/pages/wishlist" role="menuitem">Wishlist</a>
      <a href="/pages/my-studio" role="menuitem">Orders</a>
      <button class="studio-account-dropdown-btn" type="button"
              role="menuitem" data-signout>Log out</button>
    </div>`;

  menu.querySelector('[data-greeting]').textContent = 'Hi, ' + name;

  const trigger  = menu.querySelector('[data-account-trigger]');
  const dropdown = menu.querySelector('[data-account-dropdown]');

  const close = () => { dropdown.hidden = true;  trigger.setAttribute('aria-expanded', 'false'); };
  const open  = () => { dropdown.hidden = false; trigger.setAttribute('aria-expanded', 'true'); };

  trigger.addEventListener('click', (e) => { e.preventDefault(); dropdown.hidden ? open() : close(); });
  document.addEventListener('click', (e) => { if (!menu.contains(e.target)) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  menu.querySelector('[data-signout]').addEventListener('click', async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error('Sign out failed:', err);
    } finally {
      window.location.href = '/';
    }
  });
}
